import { memo, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { PostCallWithErrorResponse, simpleGetCallWithErrorResponse } from "../Api/ApiServices";
import { ApiConfig } from "../Api/ApiConfig";
import { Table } from "antd";
import _, { set } from "lodash";
import { formatToDDMMYYYY } from "../common";



const UserActivity = memo(function UserActivity(props) {

    const [filteredInfo, setFilterInfo] = useState({})

    const { showLog, handleClose, name, userId, filterData } = props

    const [userLogs, setUserLogs] = useState([])

    const getUserLogs = () => {

        PostCallWithErrorResponse(ApiConfig.GET_USER_LOGS + userId).then((res) => {

            if (res?.json?.succeded) {
                setUserLogs(res?.json?.response)
            }

        })
    }

    useEffect(() => {
        getUserLogs()
    }, [showLog])



    const handleFilters = (_, filters) => {
        setFilterInfo(filters)
    }



    const conevrDateTime = (dateObj) => {

        dateObj = new Date(dateObj)


        const options = {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true
        };

        const time12hr = dateObj.toLocaleTimeString("en-US", options);


        const datePart = dateObj.toLocaleDateString("en-GB");

        return { datePart, time12hr }
    }

    return (
        <Modal show={showLog}
            centered
            onHide={() => {
                setFilterInfo({})
                handleClose()
            }}
            size="lg"
            dialogClassName="modal-h-650"
        >
            <Modal.Header closeButton className="custom-close-btn">
                <h6 className="mb-0 mt-1">{name}</h6>
            </Modal.Header>
            <Modal.Body>
                {
                    userLogs?.length === 0 ?
                        <h4 className="text-center">Logs Not Found !</h4> :
                        <div style={{ minHeight: '400px', maxHeight: '400px', overflow: 'scroll', overflowX: 'hidden' }}>
                            <Table
                                dataSource={userLogs}
                                columns={[
                                    {
                                        title: 'Date and time',
                                        dataIndex: 'name',
                                        width: 120,
                                        render: (_, record) => {
                                            let dateTime = formatToDDMMYYYY(record?.date,'dd-mm-yy HH:mm');
                                            return <span>{dateTime}</span>;
                                        },
                                        sorter: (a, b) => new Date(a.date) - new Date(b.date),
                                    },
                                    {
                                        title: 'Activity',
                                        dataIndex: 'activity',
                                        width: 350,
                                        sorter: (a, b) => a.activity?.localeCompare(b.activity),
                                        filters: Array.from(new Set(userLogs.map(i => i.activity)))
                                            .map(act => ({ text: act, value: act })),
                                        filteredValue: filteredInfo.activity || null,
                                        onFilter: (value, record) => record.activity === value,
                                    },
                                    {
                                        title: 'view port',
                                        dataIndex: 'view',
                                        width: 50,
                                        sorter: (a, b) => a.view?.localeCompare(b.view),
                                        filters: Array.from(new Set(userLogs.map(i => i.view)))
                                            .map(act => ({ text: act, value: act })),
                                        filteredValue: filteredInfo.view || null,
                                        onFilter: (value, record) => record.view === value,
                                    },
                                    {
                                        title: 'Os', dataIndex: 'os',
                                        sorter: (a, b) => a.os?.localeCompare(b.os),
                                        width: 50,
                                        filters: Array.from(new Set(userLogs.map(i => i.os)))
                                            .map(act => ({ text: act, value: act })),
                                        filteredValue: filteredInfo.os || null,
                                        onFilter: (value, record) => record.os === value,
                                    },
                                    {
                                        title: 'Browser',
                                        dataIndex: 'browser',
                                        width: 60,
                                        sorter: (a, b) => a.browser?.localeCompare(b.browser),
                                        filters: Array.from(new Set(userLogs.map(i => i.browser)))
                                            .map(act => ({ text: act, value: act })),
                                        filteredValue: filteredInfo.browser || null,
                                        onFilter: (value, record) => record.browser === value,
                                    },
                                ]}
                                onChange={handleFilters}
                                pagination={false}
                                getPopupContainer={(triggerNode) => triggerNode.closest('.modal-content')} // ✅ bootstrap fix
                            />

                        </div>
                }
            </Modal.Body>
        </Modal >
    )

})

export default UserActivity
